import { EventEmitter } from "@angular/core";
import { StockModel } from "../../shared/models/stock.model";
import { ColumnModel } from "../../shared/models/column.model";
export class StockBuildData{
    module = {
        name: "Stock",
        new_name: "stock",
        has_dot_menu: true,
        icon:'fa-ad',
        permission:'stock',
        filtered_name: ''
    }
    
    onReload: EventEmitter < boolean > = new EventEmitter<boolean>();//Forces Reload of codeblack table on emit.
    rowFunction = (row:StockModel) => {//Generates Row for codeblack-table
        return StockModel.getListRow(row);
    }
    
    columns:ColumnModel[] = [
        {
            title: "Id",
            prop: "id",
            flex_grow: 1,
            row_accessor: "id",
            class:""//force-flex force-flex-end
        },
        {
            title: "Title",
            prop: "title",
            flex_grow: 4,
            row_accessor: "title",
        }
    ];

    constructor(){
        for(let col of this.columns){
            col = new ColumnModel(col);
        }
    }

}